/**
 * Bootstrap Vue plugins: Vuetify, Pinia, router, Font Awesome.
 * Order matters — Pinia must be installed before any composable that calls
 * useStore() during setup.
 */
import type { App } from 'vue'
import { createPinia } from 'pinia'
import vuetify from './vuetify'
import router from '@/router'

// Font Awesome (free icon packs — match ml-components which uses Pro, but we
// stay on free here. Component templates use the same `fa-solid fa-name`
// syntax via Vuetify's FA icon set.)
import { library, config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

config.autoAddCss = false
;(library.add as unknown as (...packs: unknown[]) => void)(fas, far, fab)

export function registerPlugins(app: App) {
  app.use(createPinia())
  app.use(router)
  app.use(vuetify)
  app.component('FontAwesomeIcon', FontAwesomeIcon)
}
